import { isAllowedApiOrigin } from '../../config/apiEndpoints';

/**
 * Builds authorization headers if the destination base URL is trusted (same-origin or allowlisted).
 * Prevents exfiltration of Firebase ID tokens to unauthorized external hosts.
 */
export async function buildAuthHeaders(
  baseUrl: string,
  getIdToken?: () => Promise<string | null | undefined> | string | null | undefined,
): Promise<Record<string, string>> {
  if (!getIdToken) return {};

  const cleanBase = baseUrl.trim();
  if (cleanBase && !cleanBase.startsWith('/')) {
    try {
      const url = new URL(cleanBase);
      const isBrowserSameOrigin =
        typeof window !== 'undefined' && window.location?.origin === url.origin;
      if (!isBrowserSameOrigin && !isAllowedApiOrigin(url.origin)) {
        return {};
      }
    } catch {
      return {};
    }
  }

  const raw = await (typeof getIdToken === 'function' ? getIdToken() : getIdToken);
  const token = typeof raw === 'string' ? raw.trim() : '';
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}
